export enum viewOptionValues {
  ACCESS = 'access',
  HOME = 'home',
  MOVE_IN = 'move_in',
  PARKING = 'parking',
  PROPERTY = 'property',
  STATUS = 'status',
}

export const viewOptions = [
  {
    name: 'Status',
    value: viewOptionValues.STATUS,
  },
  {
    name: 'Move-in',
    value: viewOptionValues.MOVE_IN,
  },
  {
    name: 'Home',
    value: viewOptionValues.HOME,
  },
  {
    name: 'Parking',
    value: viewOptionValues.PARKING,
  },
  {
    name: 'Property',
    value: viewOptionValues.PROPERTY,
  },
  {
    name: 'Access',
    value: viewOptionValues.ACCESS,
  },
]
